import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useField } from '@unform/core';

import {
  Container,
  SelectComponent,
  customStyles,
  ErrorMessage,
} from './styles';

export default function SelectCreatable({
  name,
  errorField,
  menuPlacement,
  isMulti,
  disabled = false,
  ...rest
}) {
  const selectCreateRef = useRef(null);
  const { fieldName, defaultValue, registerField, error } = useField(name);
  useEffect(() => {
    registerField({
      name: fieldName,
      ref: selectCreateRef.current,

      getValue: ref => {
        if (isMulti) {
          if (!ref.select.select.state.selectValue) {
            return [];
          }

          return ref.select.select.state.selectValue.map(option => option);
        } else {
          if (!ref.state.value) {
            return '';
          }
          return ref.state.value.value;
        }
      },
      setValue: (ref, value) => {
        ref.select.select.setValue(value);
      },
      clearValue(ref) {
        ref.select.select.setValue();
      },
    });
  }, [fieldName, registerField, isMulti]);

  return (
    <Container error={errorField} disabled={disabled}>
      <SelectComponent
        components={{ DropdownIndicator: null }}
        error={error}
        styles={customStyles}
        ref={selectCreateRef}
        menuPlacement={menuPlacement}
        defaultValue={defaultValue}
        isMulti={isMulti}
        isDisabled={disabled}
        {...rest}
      />

      {!!errorField && <ErrorMessage>{error || errorField}</ErrorMessage>}
    </Container>
  );
}

// SelectCreatable.defaultProps = {
//   isMulti: false,
//   searchable: false,
//   isClearable: false,
//   fill: true,
//   errorField: false,
//   menuPlacement: 'auto',
//   placeholder: 'Selecione...',
// };

SelectCreatable.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  searchable: PropTypes.bool,
  errorField: PropTypes.string,
  multiple: PropTypes.bool,
  menuPlacement: PropTypes.string,
  onChange: PropTypes.func,
  handleSelected: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
    }).isRequired,
  ),
};
